import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { MixedInsumos } from './types';

interface TabSelecaoProps {
  insumosUnicos: MixedInsumos[];
  selectedInsumos: string[];
  onToggleInsumo: (id: string) => void;
}

const TabSelecao: React.FC<TabSelecaoProps> = ({
  insumosUnicos,
  selectedInsumos,
  onToggleInsumo,
}) => (
  <div className="assistente-selecao">
    {insumosUnicos
      .slice()
      .sort((firstValue, secondValue) =>
        firstValue.nome.localeCompare(secondValue.nome),
      )
      .map((insumo) => (
        <div key={insumo.id} className="assistente-selecao-item">
          <Checkbox
            inputId={`insumo-${insumo.id}`}
            checked={selectedInsumos.includes(insumo.id)}
            onChange={() => onToggleInsumo(insumo.id)}
          />
          <label htmlFor={`insumo-${insumo.id}`}>{insumo.nome}</label>
        </div>
      ))}
  </div>
);

export default React.memo(TabSelecao);
